<template>
    <div>
        <div class="white-box mt-3">
            <div class="data-group">
                <M3FormTitle title="Locații de implementare" :checked="completed"></M3FormTitle>
                <p class="title mt-4">Vă rugăm să introduceți mai jos adresa completă a locației sau locațiilor de implementare. Proiectul poate fi implementat în mai multe locații.</p>
                <p class="title mt-4 mb-4">În cazul în care proiectul are mai multe locaţii de implementare, ţinând cont că aplicatia informatică (IMM RECOVER) permite selectarea unei singure locaţii, se va trece în aplicaţe locaţia principală, iar restul locaţiilor vor fi precizate în cererea de finanţare.</p>
                <validation-observer #default="{ invalid }" ref="observer">
                    <span class="display-none">{{ invalid }}</span>
                    <b-form ref="formular">
                        <div>
                            <div v-for="(adresa, key) in address" :key="key" class="flex" style="justify-content: space-between; align-items: center;">
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    style="width: 20%;"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="4"
                                        content-cols-lg="8"
                                        label="Localitate"
                                        class="has-icon"
                                    >
                                        <b-form-input
                                            v-model="adresa.city"
                                            type="text"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                        ></b-form-input>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    style="width: 20%;"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="4"
                                        content-cols-lg="8"
                                        label="Județ"
                                        class="has-icon"
                                    >
                                        <b-form-select
                                            v-model="adresa.state"
                                            :options="states"
                                            text-field="stateName"
                                            value-field="stateCode"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            :class="completed ?'disabled-select':''"
                                            @change="pickRegion(key)"
                                        >
                                        </b-form-select>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    style="width: 20%;"
                                >
                                    <b-form-group
                                        id="fieldset-horizontal"
                                        label-cols-lg="4"
                                        content-cols-lg="8"
                                        label="Regiune"
                                        class="has-icon"
                                    >
                                        <b-form-input
                                            v-model="adresa.region"
                                            type="text"
                                            :state="errors.length > 0 ? false : null"
                                            readonly
                                        ></b-form-input>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </b-form-group>
                                </validation-provider>
                                <validation-provider
                                    #default="{ errors }"
                                    rules="required"
                                    style="width: 34%;"
                                >
                                    <div>
                                        <b-form-group
                                            id="fieldset-horizontal"
                                            label-cols-lg="3"
                                            content-cols-lg="9"
                                            label="Adresa"
                                            class="position-relative"
                                        >
                                            <b-form-input
                                                v-model="adresa.address"
                                                type="text"
                                                name="address"
                                                :readonly="completed"
                                                :state="errors.length > 0 ? false : null"
                                                style="font-weight: bold; color: #767a95"
                                                @input="address[key] = adresa"
                                                @click.native="checkCompleted()"
                                            ></b-form-input>
                                            <b-icon-x-circle v-if="key > 0" class="delete-icon" @click="deleteAddress(key)"></b-icon-x-circle>
                                        </b-form-group>
                                    </div>
                                </validation-provider>
                            </div>
                            <div class="adauga-locatie mb-5 mt-3">
                                <div class="add-button" @click="addLocation()">
                                    <p>Adaugă locație nouă</p>
                                    <b-icon-plus-circle-fill font-scale="1.2"></b-icon-plus-circle-fill>
                                </div>
                            </div>
                        </div>
                        <hr class="mt-5">
                        <b-form-checkbox
                            v-model="completed"
                            switch
                            size="lg"
                            class="switch-box"
                            @change="completeForm()"
                        >Informațiile sunt complete și corecte</b-form-checkbox>
                    </b-form>
                </validation-observer>
            </div>
            <img src="@/assets/images/M3/M3Sketch/termenesmall.png" class="termene-icon">
        </div>
    </div>
</template>

<script>
    import M3FormTitle from '../M3FormTitle'
    import { BForm, BFormCheckboxGroup, BFormGroup, BFormCheckbox, BFormInput, BIconPlusCircleFill, BIconXCircle, BFormSelect} from "bootstrap-vue";
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import _ from "lodash";
    export default {
        components: {
            BForm,
            BFormCheckboxGroup,
            BFormGroup,
            BFormCheckbox,
            BFormInput,
            M3FormTitle,
            BFormSelect,
            BIconPlusCircleFill,
            BIconXCircle,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            acquisitions: null,
            location_address: null,
        },
        data() {
            return {
                options: [
                    { text: 'Proiectul propune construcții noi sau interventii la construcţii existente – construire/ modernizare/extindere/ consolidare', value: 'constructions' },
                    { text: 'Proiectul propune achiziția unui imobil  (Nu se permite achiziția facilităților de cazare / CAEN 5520 sau achiziția de sedii de birouri / alte activități destinate investițiilor imobiliare)', value: 'buildings' },
                    { text: 'Proiectul propune achiziția de echipamente, utilaje, intalații, mobilier, echipamente informatice, mijloace de transport, active necorporale', value: 'equipments' },
                ],
                selected: [],
                completed: null,
                data: null,
                states: [],
                address: [
                    {
                        city: '',
                        state: '',
                        region: '',
                        address: ''
                    }
                ]
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            }
        },
        watch:{
            location_address: {
                handler: function() {
                    if(this.location_address !== null){
                        this.address = this.location_address
                    }
                },
            },
            checks: {
                handler: function() {
                    this.completed = this.checks.proiectulMeuAchizitiileProiectului;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            if(this.location_address !== null){
                this.address = this.location_address
            }
            axios.get(api.API_ROOT + '/states-full/RO')
                .then( response => {
                    this.states = response.data
                })
                .catch( xhr => {
                    console.log(xhr);
                })
        },
        methods: {
            completeForm() {
                this.$refs.observer.validate().then((e) => {
                    if(!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else{
                        this.addressSend = {
                            location_address: this.address
                        }
                        this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.addressSend)
                            .then((firstResponse) => {
                                this.$toast.success(firstResponse.data)
                            }).catch((xhr) => {
                                if (xhr.status === 422) {
                                    this.errors.record(xhr.responseJSON.errors);
                                }
                                this.$toast.error(xhr.response.data.message);
                            });
                    }
                    if(this.checks.proiectulMeuAchizitiileProiectului !== this.completed)
                        this.$store.dispatch('checks/updateChecks', { name: 'proiectulMeuAchizitiileProiectului', value: this.completed })
                })
            },
            addLocation() {
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                }else {
                    this.address.push({
                        city: '',
                        state: '',
                        region: '',
                        address: ''
                    })
                }
            },
            deleteAddress(key) {
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                }else {
                    this.address.splice(key, 1)
                }
            },
            checkCompleted() {

                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                }
            },
            pickRegion(key) {
                this.address[key].region = _.filter(this.states, v => v.stateCode === this.address[key].state)[0].regionName
            }
        }
    }
</script>

<style scoped>
.white-box{
    background: #fff;
    padding: 20px;
    position: relative;
}
.data-group{
    margin: auto;
    width: 85%;
}
.flex{
    display: flex;
    align-items: flex-end;
}
.flex img{
    margin-right: 10px;
}
.disabled-select{
    background: #a1fff1 url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px !important;
}
.title{
    font-size: 14px;
    color: #5b6276;
}
.checkboxes >>> label{
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
    line-height: 23px;
}
.switch-box{
    text-align: right;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.checkboxes >>> .custom-checkbox{
    margin: 10px 0;
}
.delete-icon{
    color: var(--dangerColor);
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    right: -20px;
    cursor: pointer;
}
.form-group >>> legend{
    text-align: left;
    font-size: 14px !important;
    color: #777e90;
    font-weight: 500;
}
.form-group >>> input, input{
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    font-size: 14px;
    max-height: 30px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
}
.form-group >>> input:read-only{
    background: #a1fff1;
}
.form-group >>> .form-row{
    align-items: flex-start;
}
.adauga-locatie{
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.custom-select{
    color: #767a95;
    padding: 5px 10px;
    font-size: 14px;
    border-radius: 2px;
    max-height: 33px;
    margin: 0 !important;
    font-weight: 600;
    background: #e9ecef url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px;
}
.form-group >>> .form-row{
    align-items: center !important;
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px;
    }
}
</style>
